export * from './login/login.component';
export * from './register/register.component';
export * from './verfication/verfication.component';
export * from './forget-password/forget-password.component';
export * from './reset-password/reset-password.component';
export * from './user';
export * from './not-found/not-found.component';
// export * from './service/cognito.service';



// WEBPACK FOOTER //
// ./src/app/authentication/index.ts